import React from 'react';

import { withScreenWidget } from '@gogame/screens';

import TrackerChartsSlider from 'scenes/Trackers/Tracker/components/TrackerCharts/TrackerChartsSlider';
import { trackerReducer } from 'scenes/Trackers/Tracker/reducers';

import TrackerPresetActions from './Actions';
import TrackerPresetDescription from './Description';
import TrackerPresetFilters from './Filters';
import TrackerPresetStorage from './Storage';

export const TrackerWidget = withScreenWidget({
  title: 'Tracker',
  name: 'advertising-tracker3.0',
  reducer: trackerReducer,
  storage: <TrackerPresetStorage />,
  description: <TrackerPresetDescription />,
  filters: <TrackerPresetFilters />,
  actions: <TrackerPresetActions />,
})(({ tooltipPosStrategy }) => {
  return <TrackerChartsSlider tooltipPosStrategy={tooltipPosStrategy} />;
});

export default TrackerWidget;
